export function getIcalendarLink(
    organizationCode: string,
    facilityId: string,
    calendarGuid: string,
    storefrontSlug: string
) {
    const link =
        organizationCode + '/icalendar/' + facilityId + '/' + calendarGuid

    if (storefrontSlug === '') {
        return link
    }

    return link + '?storefrontSlug=' + storefrontSlug
}
